// ClassAssembly4B
import React from 'react';
import ClassAssembly4B  from 'views/ClassAssembly4B';

const ClassAssembly4BPage = () => {
    return <ClassAssembly4B />;
  };
  
  export default ClassAssembly4BPage;